export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const setCriticalError = (message) => ({ type: SET_ERROR, payload: message });

export const clearErrors = () => ({ type: CLEAR_ERROR });
